import { useEffect } from 'react';

const FONT_HREF = 'https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&display=swap';

/**
 * What visitors see while a site is in maintenance mode.
 * Matches the standard TMG "Under Maintenance" page.
 */
export default function MaintenancePage({ message }) {
  // Load DM Sans the same way the standalone maintenance page does.
  useEffect(() => {
    if (document.querySelector(`link[href="${FONT_HREF}"]`)) return undefined;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONT_HREF;
    document.head.appendChild(link);
    return undefined;
  }, []);

  useEffect(() => {
    const previous = document.title;
    document.title = 'Under Maintenance';
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        minHeight: '100vh',
        fontFamily: "'DM Sans', sans-serif",
        backgroundColor: '#FFD200',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 32 32"
          style={{ width: '64px', height: '64px', fill: '#333', marginBottom: '20px' }}
        >
          <path d="M30.031 23.631l-5.662-5.785c-0.369-0.369-0.985-0.369-1.354 0s-0.369 0.985 0 1.354l0.862 0.862-1.354 1.354c-0.369 0.369-0.369 0.985 0 1.354 0.123 0.123 0.369 0.246 0.615 0.246s0.492-0.123 0.615-0.246l1.354-1.354 2.831 2.831-3.815 3.815-6.892-6.892 12.062-12.062c0.369-0.369 0.369-0.985 0-1.354l-5.169-5.169c-0.123-0.123-0.369-0.246-0.615-0.246v0c-0.246 0-0.492 0.123-0.615 0.246l-6.892 7.015-7.631-7.631c-0.369-0.369-0.985-0.369-1.354 0l-5.046 5.169c-0.369 0.369-0.369 0.985 0 1.354l7.631 7.508-0.615 0.615c-0.369 0.369-0.369 0.985 0 1.354s0.985 0.369 1.354 0l9.477-9.477 3.815 3.815-11.938 12.062-4.554-4.677c-0.246-0.246-0.492-0.369-0.862-0.246-0.246 0.123-0.615 0.246-0.615 0.615l-3.2 8.369c-0.123 0.369 0 0.738 0.246 0.985 0.123 0.123 0.369 0.246 0.615 0.246 0.123 0 0.246 0 0.369 0l8.369-3.2c0 0 0 0 0 0 0.123 0 0.246-0.123 0.369-0.246l3.692-3.692 7.508 7.508c0.123 0.123 0.369 0.246 0.615 0.246s0.492-0.123 0.615-0.246l5.169-5.169c0.369-0.369 0.369-0.985 0-1.231zM10.831 14.769l-6.892-7.015 3.815-3.815 2.831 2.831-1.231 1.354c-0.369 0.369-0.369 0.985 0 1.354 0.123 0.123 0.369 0.246 0.615 0.246s0.492-0.123 0.615-0.246l1.354-1.354 2.831 2.831-3.938 3.815zM21.046 7.138l2.462-2.462 3.815 3.815-2.462 2.462-3.815-3.815zM4.923 27.077l1.969-5.046 3.077 3.2-5.046 1.846z" />
        </svg>

        <h2 style={{ fontSize: '28px', fontWeight: 600, color: '#333', margin: 0 }}>
          Under Maintenance
        </h2>

        {message ? (
          <p style={{ fontSize: '16px', color: '#333', marginTop: '12px', marginBottom: 0 }}>
            {message}
          </p>
        ) : null}
      </div>
    </div>
  );
}
